const _defaultConfig = {
  offsetX: 0,
  offsetY: 50,
};

const _scrollableElements = {
  top: { offsetX: 0, offsetY: 0 },
};

const contains = (name) => {
  return _scrollableElements.hasOwnProperty(name);
}

const calculateMove = (element) => {
  if (element.ref) {
    const elemRect = element.ref.current.getBoundingClientRect();
    return {
      offsetX: 0,
      offsetY: elemRect.top + window.pageYOffset - _defaultConfig.offsetY,
    }
  }

  return {
    offsetX: Number(element.offsetX),
    offsetY: Number(element.offsetY),
  }
};

const Scrollable = {
  register: (name, elementRef) => {
    if (contains(name)) {
      const error = {
        msg: 'Element name already exists',
      };
      throw error;
    }

    _scrollableElements[name] = {
      ref: elementRef,
    };
  },

  scrollTo: (name) => {
    if (!contains(name)) return;

    const elem = _scrollableElements[name];
    const calculatedMove = calculateMove(elem);

    window.scrollTo({
      behavior: "smooth",
      left: calculatedMove.offsetX,
      top: calculatedMove.offsetY,
    });
  }
};

export default Scrollable;
